import React, { Suspense, lazy } from 'react';
import { KeepAlive } from 'react-activation';
// import { hot } from 'react-hot-loader'; // 禁用 react-hot-loader，使用 Rsbuild 内置 HMR
import { Route, BrowserRouter, Switch } from 'react-router-dom';
import App from 'src/components/app';
import ErrorBoundary from 'src/components/app/ErrorBoundary';
import Page from 'src/components/page';
import chatMedicalManage from 'src/pages/chatMedicalManage/route';
import clinicRoute from 'src/pages/clinic/route';
import couponRoutes from 'src/pages/coupon/couponRoutes'; // ump模块
import doctorRoutes from 'src/pages/doctor/route';  // 【医生详情】【医生评价】【医生列表】
import drugRoutes from 'src/pages/drug/route'; // 药品
import enterpriseRoutes from 'src/pages/enterprise/route'; // 企微模块
import examinationRoute from 'src/pages/examination/route';
import expressRoutes from 'src/pages/express/route'; // 【物流列表】【物流详情】
import familyDoctorRoutes from 'src/pages/familyDoctor/route'; // 家庭医生模块
import gluRoutes from 'src/pages/glu/route';  // 【血糖介绍】【血糖值】【多个权益页面】
import groupRoute from 'src/pages/groupGoods/route'; // 视频问诊模块
import healthArchiveRoutes from 'src/pages/healthArchive/route'; // 健康档案模块
import massageTherapyRoutes from 'src/pages/massageTherapy/route'; // 中医理疗
import mentalConsultRoutes from 'src/pages/mentalConsult/route';
import opTestRoutes from 'src/pages/optest/route'; // 骨松测试模块
import patientRoutes from 'src/pages/patients/route'; // 【编辑患者】【患者信息】【健康档案】【患者列表】
import mineRoutes from 'src/pages/personalCenter/route'; // 【我的地址】【我的优惠券】【我的医生】【我的订单】【我的·····】
import promotionRoute from 'src/pages/promotion/route'; // 推广类相关路由
import rightsRoute from 'src/pages/rights/route'; // 新权益类页面路由
import serviceRoutes from 'src/pages/serviceApply/route'; // 服务卡申请模块
import solidMedicalPageRoutes from 'src/pages/solidMedicine/route'; // 药省保问诊模块
import specialistRoutes from 'src/pages/specialist/route'; // 专科中心
import staticRoutes from 'src/pages/static/route';  // 所有的静态活动页面
import textRoutes from 'src/pages/textInquiryChat/route'; // 图文问诊模块
import thirdRoutes from 'src/pages/third/route'; // 第三方相关页面模块
import videoRoutes from 'src/pages/video/route'; // 视频问诊模块
import szPhysicalRoutes from 'subPackages/szPhysical/pages/routes';
import { Loading, ActivityIndicator } from 'zarm';
export interface routersTypes {
  path: string;
  name: string;
  component: any;
  auth?: boolean;
  exact?: boolean;
  sensitive?: boolean;
  title?: string | (() => string);
  realAuth?: boolean;
  keepAlive?: boolean;
}

const NotFoundPage: routersTypes = { path: '*', name: 'NotPage', component: () => import('./noPage'), title: '404' };

const routers: routersTypes[] = [
  {
    path: '/hospital/inquiry/submit',
    name: 'InquiryformSubmit',
    component: () => import(/* webpackPrefetchPlaceHolder */ './inquiryForm'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '图文问诊',
  },
  {
    path: '/hospital/inquiry/office',
    name: 'InquiryformOffice',
    component: () => import(/* webpackPrefetchPlaceHolder */ './inquiryForm/office'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '科室选择',
  },
  {
    path: '/hospital/inquiryform',
    name: 'aiGuideInquiry',
    component: () => import(/* webpackPrefetchPlaceHolder */ './inquiryForm/aiGuideNext'),
    auth: true,
    exact: true,
    realAuth: false,
    title: '众安互联网医院',
    keepAlive: true,
  },
  {
    path: '/hospital/consultationRecord',
    name: 'aiGuideInquiry',
    component: () => import(/* webpackPrefetchPlaceHolder */ './consultationRecord'),
    auth: true,
    exact: true,
    realAuth: false,
    title: '咨询记录',
  },
  {
    path: '/hospital/inquiryform/old',
    name: 'aiGuideInquiry',
    component: () => import(/* webpackPrefetchPlaceHolder */ './inquiryForm/aiGuide'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '众安互联网医院',
  },
  {
    path: '/hospital/inquiryform/thyroid',
    name: 'aiGuideInquiry',
    component: () => import(/* webpackPrefetchPlaceHolder */ './inquiryForm/aiGuideThyroid'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '众安互联网医院',
  },
  {
    path: '/hospital/inquiryplain',
    name: 'aiGuideInquiry',
    component: () => import(/* webpackPrefetchPlaceHolder */ './inquiryForm/plainGuide'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '众安互联网医院',
  },
  {
    /* 该地址为 专科视频预约问诊进入的视频下单流程，不走图文逻辑*/
    path: '/hospital/video/booking',
    name: 'FakeVideo',
    component: () => import(/* webpackPrefetchPlaceHolder */ './inquiryForm/aiGuide'),
    auth: true,
    exact: true,
    title: '视频问诊',
  },
  {
    path: '/hospital/choosedepartment',
    name: 'ChooseDepartment',
    component: () => import(/* webpackPrefetchPlaceHolder */ './inquiryForm/components/ChooseDepartments/index'),
    auth: true,
    exact: true,
    title: '选择科室',
  }, {
    path: '/hospital/choosedoctorlist',
    name: 'DoctorList',
    component: () => import(/* webpackPrefetchPlaceHolder */ './inquiryForm/components/ChooseDepartments/doctorList'),
    auth: true,
    exact: true,
    title: '选择好医',
  },
  {
    path: '/hospital/drugdetail',
    name: 'DrugDetail',
    component: () => import(/* webpackPrefetchPlaceHolder */ './drugDetail'),
    auth: true,
    exact: true,
    title: '药品详情',
  }, {
    path: '/hospital/electronicSignature',
    name: 'ElectronicSignature',
    component: () => import(/* webpackPrefetchPlaceHolder */ './electronicSignature'),
    auth: false,
    exact: true,
    title: '电子签名上传',
  }, {
    path: '/hospital/evaluate',
    name: 'Evaluate',
    component: () => import(/* webpackPrefetchPlaceHolder */ './evaluate'),
    auth: true,
    exact: true,
    title: '评价医生',
  }, {
    path: '/hospital/umpEvaluate',
    name: 'umpEvaluate',
    component: () => import(/* webpackPrefetchPlaceHolder */ './umpEvaluate'),
    auth: true,
    exact: true,
    title: '评价医生',
  }, {
    path: '/hospital/umpEvaluatecheck',
    name: 'umpEvaluateCheck',
    component: () => import(/* webpackPrefetchPlaceHolder */ './umpEvaluate/check'),
    auth: true,
    exact: true,
    title: '查看评价',
  }, {
    path: '/hospital/evaluatesuccess',
    name: 'EvaluateSuccess',
    component: () => import(/* webpackPrefetchPlaceHolder */ './evaluate/success'),
    auth: true,
    exact: true,
    title: '评价成功',
  }, {
    path: '/hospital/evaluatecheck',
    name: 'EvaluateCheck',
    component: () => import(/* webpackPrefetchPlaceHolder */ './evaluate/check'),
    auth: true,
    exact: true,
    title: '查看评价',
  }, {
    path: '/hospital/init',
    name: 'Init',
    component: () => import(/* webpackPrefetchPlaceHolder */ './init'),
    auth: false,
    exact: true,
    title: '众安互联网医院',
  }, {
    path: '/hospital/error',
    name: 'InitError',
    component: () => import(/* webpackPrefetchPlaceHolder */ './init/error'),
    auth: false,
    exact: true,
    title: '众安互联网医院',
  }, {
    path: '/hospital/close',
    name: 'InitError',
    component: () => import(/* webpackPrefetchPlaceHolder */ './init/close'),
    auth: false,
    exact: true,
    title: '众安互联网医院',
  }, {
    path: '/hospital/invoice',
    name: 'Invoice',
    component: () => import(/* webpackPrefetchPlaceHolder */ './innvoice'),
    auth: true,
    exact: true,
    title: '病历',
  }, {
    path: '/hospital/invoice/address',
    name: 'Invoice',
    component: () => import(/* webpackPrefetchPlaceHolder */ './innvoice/address'),
    auth: true,
    exact: true,
    title: '选择地址',
  }, {
    path: '/hospital/invoice/editaddress',
    name: 'Invoice',
    component: () => import(/* webpackPrefetchPlaceHolder */ './innvoice/editAddress'),
    auth: true,
    exact: true,
    title: '编辑地址',
  }, {
    path: '/hospital/invoice/editaddress',
    name: 'Invoice',
    component: () => import(/* webpackPrefetchPlaceHolder */ './innvoice/editAddress'),
    auth: true,
    exact: true,
    title: '编辑地址',
  }, {
    path: '/hospital/orderdetail',
    name: 'OrderDetail',
    component: () => import(/* webpackPrefetchPlaceHolder */ './orderDetail'),
    auth: true,
    exact: true,
    title: '订单详情',
  }, {
    path: '/hosopt',
    name: 'OptLogin',
    component: () => import(/* webpackPrefetchPlaceHolder */ './otp'),
    auth: false,
    exact: false,
    title: '众安互联网医院',
  }, {
    path: '/hospital/optexpress',
    name: 'OtpExpressDetail',
    component: () => import(/* webpackPrefetchPlaceHolder */ './otp/expressDetail'),
    auth: false,
    exact: true,
    title: '订单详情',
  }, {
    path: '/hospital/payordersuccess',
    name: 'PayOrderSuccess',
    component: () => import(/* webpackPrefetchPlaceHolder */ './payOrderSuccess'),
    auth: true,
    exact: true,
    title: '支付成功',
  },{
    path: '/hospital/payordersuccess/ysb',
    name: 'PayOrderSuccessYSB',
    component: () => import(/* webpackPrefetchPlaceHolder */ './payOrderSuccess/ysb'),
    auth: true,
    exact: true,
    title: '支付成功',
  }, {
    path: '/hospital/paysuccess',
    name: 'PaySuccess',
    component: () => import(/* webpackPrefetchPlaceHolder */ './paySuccess'),
    auth: true,
    exact: true,
    title: '支付成功',
  }, {
    path: '/hospital/paySuccess/await',
    name: 'PaySuccess',
    component: () => import(/* webpackPrefetchPlaceHolder */ './paySuccess/await'),
    auth: true,
    exact: true,
    title: '问诊等待',
  }, {
    path: '/hospital/prescriptiondetail',
    name: 'PrescriptionDetail',
    component: () => import(/* webpackPrefetchPlaceHolder */ './prescriptionDetail'),
    auth: true,
    exact: true,
    title: '处方单详情',
  }, {
    path: '/hospital/report',
    name: 'Report',
    component: () => import(/* webpackPrefetchPlaceHolder */ './report'),
    auth: true,
    exact: true,
    title: '详情',
  }, {
    path: '/hospital/report/invoice',
    name: 'ReportInvoice',
    component: () => import(/* webpackPrefetchPlaceHolder */ './report/relateInvoice'),
    auth: true,
    exact: true,
    title: '问诊单关联订单',
  }, {
    path: '/hospital/shoppingcart',
    name: 'ShoppingCart',
    component: () => import(/* webpackPrefetchPlaceHolder */ './shoppingCart'),
    auth: true,
    exact: true,
    title: '订单确认',
  },
  {
    path: '/hospital/thyroid_sign',
    name: 'ThyroidSign',
    component: () => import(/* webpackPrefetchPlaceHolder */ './thyroidHospital/sign'),
    auth: false,
    exact: true,
    title: '门诊预约',
  }, {
    path: '/hospital/thyroid_intro',
    name: 'ThyroidIntro',
    component: () => import(/* webpackPrefetchPlaceHolder */ './thyroidHospital/intro'),
    auth: false,
    exact: true,
    title: '甲状腺问题不可怕',
  }, {
    path: '/hospital/mentalTalking',
    name: 'mentalTalking',
    component: () => import(/* webpackPrefetchPlaceHolder */ './thyroidHospital/mentalTalking'),
    auth: false,
    exact: true,
    title: '心理倾诉',
  },
  {
    path: '/hospital/claims/inquiry',
    name: 'ClaimsInquiry',
    component: () => import(/* webpackPrefetchPlaceHolder */ './claims'),
    auth: true,
    exact: true,
    title: '直赔问诊',
  },
  {
    path: '/hospital/mallRights/claims',
    name: 'MallRightsClaims',
    component: () => import(/* webpackPrefetchPlaceHolder */ './mallRights/claims'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '购药保障',
  },
  {
    path: '/hospital/mallClaims/inquiry',
    name: 'MallClaimsInquiry',
    component: () => import(/* webpackPrefetchPlaceHolder */ './mallClaims'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '购药保障',
  },
  {
    path: '/hospital/mallClaims/:vasCode',
    name: 'MallClaimsByVasCode',
    component: () => import(/* webpackPrefetchPlaceHolder */ './mallClaims'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '购药保障',
  },
  {
    path: '/hospital/cainiaoclaims/inquiry',
    name: 'CainiaoClaimsInquiry',
    component: () => import(/* webpackPrefetchPlaceHolder */ './cainiaoClaims'),
    auth: true,
    exact: true,
    title: '图文问诊',
  },
  {
    path: '/hospital/aliclaims/inquiry',
    name: 'AliClaimsInquiry',
    component: () => import(/* webpackPrefetchPlaceHolder */ './aliClaims'),
    auth: true,
    exact: true,
    title: '图文问诊', // 阿里非菜鸟流程
  },
  {
    path: '/hospital/mobile-policy',
    name: 'MobilePolicy',
    component: () => import(/* webpackPrefetchPlaceHolder */ './mobile-policy'),
    auth: false,
    exact: true,
    title: '保单权益',
  },
  {
    path: '/hospital/login',
    name: 'Login',
    component: () => import(/* webpackPrefetchPlaceHolder */ './login'),
    auth: false,
    exact: true,
    title: '用户登录',
  }, {
    path: '/hospital/certification',
    name: 'Certification',
    component: () => import(/* webpackPrefetchPlaceHolder */ './certification'),
    auth: true,
    exact: true,
    title: '实名认证',
  }, {
    path: '/hospital/certification/select',
    name: 'Certification',
    component: () => import(/* webpackPrefetchPlaceHolder */ './certification/select'),
    auth: true,
    exact: true,
    title: '实名选择',
  }, {
    path: '/hospital/home',
    name: 'Home',
    component: () => import(/* webpackPrefetchPlaceHolder */ './home/index'),
    auth: false,
    exact: true,
    title: '众安互联网医院',
  }, {
    path: '/hospital/middlepage/autoservpack',
    name: 'autoservpack',
    component: () => import(/* webpackPrefetchPlaceHolder */ './middlePage/autoServpack'),
    auth: true,
    exact: true,
    title: '众安互联网医院',
  }, {
    path: '/hospital/middlepage/didi',
    name: 'middlePageDidi',
    component: () => import(/* webpackPrefetchPlaceHolder */ './middlePage/didi'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '众安互联网医院',
  }, {
    path: '/hospital/middlePage',
    name: 'middlePage',
    component: () => import(/* webpackPrefetchPlaceHolder */ './middlePage/index'),
    auth: false,
    exact: true,
    title: '众安互联网医院',
  }, {
    path: '/hospital/middlePage/vasdirect',
    name: 'vasdirect',
    component: () => import(/* webpackPrefetchPlaceHolder */ './middlePage/vasdirect'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '众安互联网医院',
  }, {
    path: '/hospital/pdf',
    name: 'Pdf',
    component: () => import(/* webpackPrefetchPlaceHolder */ './pdf'),
    auth: false,
    exact: true,
    title: '众安互联网医院',
  }, {
    path: '/hospital/pureimg',
    name: 'pureimg',
    component: () => import(/* webpackPrefetchPlaceHolder */ './pureImg'),
    auth: false,
    exact: true,
    title: '众安互联网医院',
  }, {
    path: '/hospital/about',
    name: 'About',
    component: () => import(/* webpackPrefetchPlaceHolder */ './about'),
    auth: false,
    exact: true,
    title: '众安互联网医院',
  }, {
    path: '/hospital/refund',
    name: 'Refund',
    component: () => import(/* webpackPrefetchPlaceHolder */ './refund'),
    auth: true,
    exact: true,
    title: '退款',
  }, {
    path: '/hospital/servicelist',
    name: 'serviceList',
    component: () => import(/* webpackPrefetchPlaceHolder */ './serviceCardList'),
    auth: true,
    exact: false,
    title: '服务进度',
  }, {
    path: '/hospital/auth',
    name: 'auth',
    component: () => import(/* webpackPrefetchPlaceHolder */ './auth'),
    auth: true,
    exact: true,
    // realAuth: true,
    title: '授权',
  }, {
    path: '/hospital/noidauth',
    name: 'noidauth',
    component: () => import(/* webpackPrefetchPlaceHolder */ './auth'),
    auth: true,
    exact: true,
    realAuth: false,
    title: '授权',
  }, {
    path: '/hospital/preauth',
    name: 'preauth',
    component: () => import(/* webpackPrefetchPlaceHolder */ './auth/beforeAuth'),
    auth: true,
    exact: true,
    title: '授权',
  }, {
    path: '/hospital/feedback',
    name: 'feedback',
    component: () => import(/* webpackPrefetchPlaceHolder */ './feedback'),
    auth: true,
    exact: true,
    title: '意见反馈',
  },
  {
    path: '/hospital/doctor-manager-summary',
    name: 'doctorManagerSummary',
    component: () => import(/* webpackPrefetchPlaceHolder */ './DoctorManagerSummary'),
    // auth: true,
    exact: true,
    // realAuth: true,
    title: '众安健康管家',
  },
  {
    path: '/hospital/lottery-draw-for-new-user',
    name: 'lotteryDrawForNewUser',
    component: () => import(/* webpackPrefetchPlaceHolder */ './LotteryDrawForNewUser'),
    auth: true,
    exact: true,
    // realAuth: true,
    title: '众安新人福利抽大奖',
  },
  {
    path: '/hospital/jump-applets/:source',
    name: 'jumpApplets',
    component: () => import(/* webpackPrefetchPlaceHolder */ './jumpApplets'),
    auth: false,
    exact: true,
    realAuth: false,
    title: '众安互联网医院',
  }, {
    path: '/hospital/open-applets/:id',
    name: 'openApplets',
    component: () => import(/* webpackPrefetchPlaceHolder */ './jumpApplets/open'),
    auth: false,
    exact: true,
    realAuth: false,
    title: '众安互联网医院',
  }, {
    path: '/hospital/unionauth',
    name: 'jumpApplets',
    component: () => import(/* webpackPrefetchPlaceHolder */ './union/unionAuth'),
    auth: false,
    exact: true,
    realAuth: false,
    title: '众安互联网医院',
  }, {
    path: '/hospital/unionpay',
    name: 'jumpApplets',
    component: () => import(/* webpackPrefetchPlaceHolder */ './union/unionPay'),
    auth: false,
    exact: true,
    realAuth: false,
    title: '银联支付',
  }, {
    path: '/hospital/casedetail',
    name: 'caseDetail',
    component: () => import(/* webpackPrefetchPlaceHolder */ './caseDetail'),
    auth: false,
    exact: true,
    realAuth: false,
    title: '大家都在问',
  },
  {
    path: '/hospital/home/articleweekly',
    name: 'caseDetail',
    component: () => import(/* webpackPrefetchPlaceHolder */ './home/articleWeekly'),
    auth: false,
    exact: true,
    realAuth: false,
    title: '壹周医选',
  },
  {
    path: '/hospital/selectcoupon',
    name: 'selectCoupon',
    component: () => import(/* webpackPrefetchPlaceHolder */ './selectCoupon'),
    auth: false,
    exact: true,
    realAuth: false,
    title: '选择优惠券',
  },
  {
    path: '/hospital/zaOfficialAccountMyRights',
    name: 'zaOfficialAccountMyRights',
    component: () => import(/* webpackPrefetchPlaceHolder */ './zaOfficialAccountMyRights'),
    auth: false,
    exact: true,
    realAuth: false,
    title: '我的权益',
  },
  {
    path: '/hospital/queryMyRights',
    name: 'queryMyRights',
    component: () => import(/* webpackPrefetchPlaceHolder */ './zaOfficialAccountMyRights/queryMyRights'),
    auth: false,
    exact: true,
    realAuth: false,
    title: '保单查询',
  },
  {
    path: '/hospital/allservice',
    name: 'allservice',
    component: () => import(/* webpackPrefetchPlaceHolder */ './allServices'),
    auth: false,
    exact: true,
    realAuth: false,
    title: '全部服务',
  }, {
    path: '/hospital/allservice',
    name: 'allservice',
    component: () => import(/* webpackPrefetchPlaceHolder */ './allServices'),
    auth: false,
    exact: true,
    realAuth: false,
    title: '全部服务',
  }, {
    path: '/hospital/physicalExamination',
    name: 'physicalexamination',
    component: () => import(/* webpackPrefetchPlaceHolder */ './physicalExamination'),
    auth: false,
    exact: true,
    realAuth: false,
    title: '商品详情',
  },
  {
    path: '/hospital/physicalExamination/orderConfirm',
    name: 'ConfirmOrder',
    component: () => import(/* webpackPrefetchPlaceHolder */ './physicalExamination/confirmOrder'),
    auth: true,
    exact: true,
    title: '确认订单',
  },
  {
    path: '/hospital/physicalExamination/paysuccess',
    name: 'physicalExaminationPaysuccess',
    component: () => import(/* webpackPrefetchPlaceHolder */ './physicalExamination/paySuccess'),
    auth: true,
    exact: true,
    title: '众安互联网医院',
  },
  {
    path: '/hospital/healthManage',
    name: 'healthManage',
    component: () => import(/* webpackPrefetchPlaceHolder */ './healthManage'),
    auth: true,
    exact: true,
    sensitive: true,
    title: '健康管理',
  },
  {
    path: '/hospital/oauth',
    name: 'oauth',
    component: () => import(/* webpackPrefetchPlaceHolder */ './oauth'),
    auth: false,
    exact: true,
    title: '授权',
  },
  {
    path: '/hospital/questionnaire',
    name: 'oauth',
    component: () => import(/* webpackPrefetchPlaceHolder */ './questionnaire'),
    auth: false,
    exact: true,
    title: '健康中心咨询登记',
  },
  {
    path: '/hospital/questionnaire/success',
    name: 'oauth',
    component: () => import(/* webpackPrefetchPlaceHolder */ './questionnaire/success'),
    auth: false,

    exact: true,
    title: '提交成功',
  },
  // ...homeRoutes,
  ...doctorRoutes,
  ...staticRoutes,
  ...expressRoutes,
  ...gluRoutes,
  ...mineRoutes,
  ...patientRoutes,
  // ...outpatientRoutes,
  ...videoRoutes,
  ...serviceRoutes,
  ...opTestRoutes,
  ...enterpriseRoutes,
  ...couponRoutes,
  ...textRoutes,
  ...drugRoutes,
  ...specialistRoutes,
  ...massageTherapyRoutes,
  ...thirdRoutes,
  ...familyDoctorRoutes,
  ...chatMedicalManage,
  ...mentalConsultRoutes,
  ...clinicRoute,
  ...examinationRoute,
  ...rightsRoute,
  ...promotionRoute,
  ...solidMedicalPageRoutes,
  ...groupRoute,
  ...healthArchiveRoutes,
  ...szPhysicalRoutes,
];

const Routes = () => (
  <BrowserRouter>
    <ErrorBoundary>
      <App>
        <Switch>
          {
            [...routers, NotFoundPage].map((item, index) => {
              const SingleDynamicComponent = lazy(() => item.component());

              return (
                <Route
                  key={index}
                  name={item.name}
                  path={item.path}
                  exact={item.exact || false}
                  sensitive={item.sensitive || false}
                  render={(props: any) => (
                    <Suspense fallback={<Loading content={<ActivityIndicator />} />}>
                      <Page singleConfig={item} {...props}>
                        {item.keepAlive ? (
                          <KeepAlive name={item.path} id={item.path}>
                            <SingleDynamicComponent {...props} />
                          </KeepAlive>
                        ) : (
                          <SingleDynamicComponent {...props} />
                        )}
                      </Page>
                    </Suspense>
                  )}
                />
              );
            })
          }
        </Switch>
      </App>
    </ErrorBoundary>
  </BrowserRouter>
);


// 禁用 react-hot-loader，使用 Rsbuild 内置 HMR
// export default hot(module)(Routes);
export default Routes;
